import React from 'react';
import { get } from 'lodash';
import { Col, Row } from 'react-bootstrap';

import { InternalButtonBar } from '../../../layout/components';
import { Button, InfoLabel, Loader } from '../../../../common/components';
import AssignNewSourceGroupModal from '../../../broker/components/AssignNewSourceGroupModal/AssignNewSourceGroupModal';

import getIncludedResource from '../../../../helpers/getIncludedResource';
import displayName from '../../../../helpers/displayName';
import { brokerStatuses } from '../../../../schemas/broker';
import './TrackingLinkShow.scss';

const LABEL_SIZE = 2;

const Url = ({ productName, url }) => (
  <div className={'url'}>
    <span className={'url-product-name'}>{productName}:</span>{' '}
    <a href={url + '&skipcache=true'} target={'_blank'}>
      {' '}
      {url}
    </a>
  </div>
);

const TrackingLinkShow = ({ resource, onRefreshData }) => {
  if (!resource) {
    return <Loader />;
  }
  const sources = getIncludedResource(resource.data, resource.included, 'sources');
  const source = sources.length > 0 ? sources[0] : null;

  const isWhiteLabel = resource.data.attributes.broker_type === 'introducer';

  const urlsList = resource.data.relationships.default_product_urls?.meta ?? [];

  const sourceType = getIncludedResource(source, resource.included, 'source_type');

  return (
    <>
      <Row>
        <Col sm={12}>
          <InfoLabel
            label="Display Number"
            value={resource?.data?.attributes?.metadata?.display_phone_number ?? ''}
            labelSize={2}
            smFieldSize={4}
          />

          <InfoLabel
            name="sourceName"
            label="Source"
            labelSize={LABEL_SIZE}
            smFieldSize={4}
            value={`${source?.attributes?.name} / ${source?.attributes?.source_type}`}
          />

          <InfoLabel
            label="Renewals Enabled"
            labelSize={LABEL_SIZE}
            smFieldSize={4}
            value={resource.data.attributes.metadata.renewals_enabled ? 'Yes' : 'No'}
          />
          <InfoLabel
            label="Can use data for marketing"
            labelSize={LABEL_SIZE}
            smFieldSize={4}
            value={resource.data.attributes.metadata.allow_marketing ? 'Yes' : 'No'}
          />
          {!isWhiteLabel && (
            <>
              <InfoLabel
                label="Sales Banner Enabled"
                labelSize={LABEL_SIZE}
                smFieldSize={4}
                value={
                  resource.data.attributes.metadata.sales_banner_enabled ? 'Yes' : 'No'
                }
              />
              <InfoLabel
                label="Home Insurance Question Enabled"
                labelSize={LABEL_SIZE}
                smFieldSize={4}
                value={
                  resource.data.attributes.metadata.home_insurance_marketing_enabled
                    ? 'Yes'
                    : 'No'
                }
              />
              <InfoLabel
                label="Car Insurance Question Enabled"
                labelSize={LABEL_SIZE}
                smFieldSize={4}
                value={
                  resource.data.attributes.metadata.car_insurance_marketing_enabled
                    ? 'Yes'
                    : 'No'
                }
              />
            </>
          )}
          <InfoLabel
            label="Tracking Url(s)"
            labelSize={12}
            smFieldSize={10}
            isLowerCase
            value={urlsList?.map((url) => (
              <Url productName={url.product_name} url={url.url} />
            ))}
          />
        </Col>
      </Row>
      <div className="hr" />
      <Row>
        <Col sm={12}>
          <InfoLabel
            label="Status"
            value={displayName(
              brokerStatuses[get(resource, 'data.attributes.status', 'applied')],
            )}
            smFieldSize={4}
            labelSize={LABEL_SIZE}
          />

          <InfoLabel
            label="Created At"
            date={true}
            smFieldSize={4}
            value={resource.data.attributes.created_at}
            labelSize={LABEL_SIZE}
          />

          <InfoLabel
            label="Updated At"
            date={true}
            smFieldSize={4}
            value={resource.data.attributes.updated_at}
            labelSize={LABEL_SIZE}
          />
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <InternalButtonBar
            buttons={[
              {
                permissions: ['broker.edit'],
                button: (
                  <Button
                    key={'edit'}
                    label={'Edit Tracking Link'}
                    link
                    to={`/admin/tracking-links/${resource.data.id}/edit`}
                    className="pull-right"
                    bsStyle="primary"
                    rightIcon="pencil-square-o"
                  />
                ),
              },
              {
                permissions: ['marketing.source_create'],
                button: (
                  <AssignNewSourceGroupModal
                    key={'assignsourcegroup'}
                    source={source}
                    sourceTypeId={sourceType?.data?.id}
                    brokerId={resource.id}
                    onRefreshData={onRefreshData}
                  />
                ),
              },
            ]}
          />
        </Col>
      </Row>
    </>
  );
};

export default TrackingLinkShow;
